/* eslint-disable no-unused-vars */
// import 'amfe-flexible';
import '@babel/polyfill';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {
  Button,
  Loading,
  Tip,
  Toast,
  Toolbar,
  TabBar,
  TabPanels,
  Checkbox,
  Checker,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Input,
  Textarea,
  Select,
  Switch,
  Rate,
  Upload,
  Form,
  Popup,
  Picker,
  CascadePicker,
  DatePicker,
  TimePicker,
  SegmentPicker,
  Dialog,
  ActionSheet,
  Drawer,
  ImagePreview,
  Scroll,
  Slide,
  IndexList,
  Swipe,
  Sticky,
  ScrollNav,
  ScrollNavBar,
} from 'cube-ui';
import FastClick from 'fastclick';
import VueWechatTitle from 'vue-wechat-title';
import wx from 'weixin-js-sdk';
import { LightBox, LightBoxImg, LightBoxTxt } from 'vue-ydui/dist/lib.rem/lightbox';
import layer from 'vue-layer-mobile';

import 'echarts/lib/chart/bar';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'vue-layer-mobile/need/layer.css';

import App from './App';
import router from './router';
import store from './store';
import * as filters from './filters';
import { appInit } from './utils/util';
import UI from './utils/ui';
import './utils/validator';
import '../static/css/style.css';
import '../static/css/common.css';


Vue.use(Button);
Vue.use(Loading);
Vue.use(Tip);
Vue.use(Toast);
Vue.use(Toolbar);
Vue.use(TabBar);
Vue.use(TabPanels);
Vue.use(Checkbox);
Vue.use(Checker);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Input);
Vue.use(Textarea);
Vue.use(Select);
Vue.use(Switch);
Vue.use(Rate);
Vue.use(Upload);
Vue.use(Form);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(CascadePicker);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(SegmentPicker);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(Drawer);
Vue.use(ImagePreview);
Vue.use(Scroll);
Vue.use(Slide);
Vue.use(IndexList);
Vue.use(Swipe);
Vue.use(Sticky);
Vue.use(ScrollNav);
Vue.use(ScrollNavBar);
Vue.use(VueWechatTitle);
Vue.use(VueAxios, axios);
Vue.use(layer);

Vue.component(LightBox.name, LightBox);
Vue.component(LightBoxImg.name, LightBoxImg);
Vue.component(LightBoxTxt.name, LightBoxTxt);

Vue.prototype.$wechat = wx;
Vue.prototype.$UI = UI;

Vue.config.productionTip = true;
FastClick.attach(document.body);

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

/**
 * 提示错误信息
 */
// const errorHandler = (error, vm) => {
//   console.error('抛出全局异常');
//   console.error(vm);
//   alert(error);
// };
//
// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = error => errorHandler(error, this);

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});

appInit();



// WEBPACK FOOTER //
// ./src/main.js